/* Sovereign first-party attribution (research/5E). ~2 KB, no dependencies, no personal data.
   1. mints a visitor id (sv_cid) and keeps it 90 days
   2. reads the ad keys from the landing URL (sv_ad, ad_id, ...) and remembers them for the session
   3. writes them as cart attributes (/cart/update.js) and into the buy form's hidden fields, so the order carries them
   4. optionally beacons view / scroll / cta / dwell to the Sovereign server (data-beacon), never the customer's identity
   Honours the Global Privacy Control signal: with GPC on, no beacon is sent and fbclid is not stored. */
(function () {
  var s = document.currentScript || document.querySelector('script[src*="sv.js"]');
  var d = (s && s.dataset) || {};
  var q = new URLSearchParams(location.search);
  var K = 'sv_cid';
  var gpc = !!(navigator.globalPrivacyControl);

  function cookie(name) {
    var m = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
    return m ? decodeURIComponent(m[1]) : '';
  }
  function store(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function load(k) { try { return localStorage.getItem(k) || ''; } catch (e) { return ''; } }
  function remember(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function recall(k) { try { return sessionStorage.getItem(k) || ''; } catch (e) { return ''; } }

  var cid = load(K) || cookie(K);
  if (!cid) { cid = Date.now().toString(36) + Math.random().toString(36).slice(2, 10); }
  store(K, cid);
  document.cookie = K + '=' + encodeURIComponent(cid) + ';path=/;max-age=7776000;SameSite=Lax';

  var keys = ['sv_ad', 'ad_id', 'adset_id', 'campaign_id', 'placement', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];
  if (!gpc) keys.push('fbclid');
  var attrs = { sv_cid: cid };
  keys.forEach(function (k) {
    var v = q.get(k) || recall('sv_' + k);
    if (v) { v = String(v).slice(0, 120); attrs[k] = v; remember('sv_' + k, v); }
  });
  attrs.sv_landing = location.pathname.slice(0, 200);

  // hidden line-item properties in the buy form (belt) ...
  document.querySelectorAll('input[data-sv]').forEach(function (i) { i.value = attrs[i.getAttribute('data-sv')] || ''; });
  // ... and cart attributes (braces): the order carries both
  try {
    fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs }) }).catch(function () {});
  } catch (e) {}

  var beacon = d.beacon || '';
  var t0 = Date.now();
  function send(event, extra) {
    if (!beacon || gpc) return;
    var body = JSON.stringify({ sv_cid: cid, sv_ad: attrs.sv_ad || '', ad_id: attrs.ad_id || '', event: event,
      url: location.pathname, product: d.product || '', dwell_ms: Date.now() - t0, data: extra || {} });
    try {
      if (navigator.sendBeacon) { navigator.sendBeacon(beacon, new Blob([body], { type: 'application/json' })); }
      else { fetch(beacon, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body, keepalive: true }).catch(function () {}); }
    } catch (e) {}
  }
  send('view');
  var marks = { 50: false, 90: false };
  window.addEventListener('scroll', function () {
    var h = document.documentElement;
    var pct = Math.round(100 * (window.scrollY + window.innerHeight) / Math.max(1, h.scrollHeight));
    [50, 90].forEach(function (m) { if (!marks[m] && pct >= m) { marks[m] = true; send('scroll', { pct: m }); } });
  }, { passive: true });
  var form = document.getElementById('sov-buy-form');
  if (form) form.addEventListener('submit', function () { send('cta'); });
  window.addEventListener('pagehide', function () { send('leave'); });
})();
